import React from 'react';

/**
 * Gemeinsames Karten-Layout fuer Login/Registrierung samt Eingabefeld,
 * Fehlermeldung und Absende-Button (haelt beide Seiten konsistent).
 */
export default function AuthCard({ titel, untertitel, children }) {
  return (
    <div className="w-full max-w-sm animate-fade-in-up rounded-2xl border border-line bg-paper-soft/80 p-8 shadow-sm backdrop-blur-sm">
      <div className="mb-6 text-center">
        <p className="mb-2 font-mono text-xs uppercase tracking-[0.2em] text-ink-muted">
          Aktienanalyse
        </p>
        <h1 className="font-serif text-3xl font-semibold tracking-tight text-ink">{titel}</h1>
        {untertitel && <p className="mt-2 text-sm text-ink-soft">{untertitel}</p>}
      </div>
      {children}
    </div>
  );
}

/** Beschriftetes Eingabefeld. */
AuthCard.Feld = function Feld({ label, ...props }) {
  return (
    <label className="flex flex-col gap-1 text-sm">
      <span className="font-medium text-ink-soft">{label}</span>
      <input
        {...props}
        required
        className="rounded-lg border border-line bg-paper px-3 py-2 text-ink outline-none transition-colors focus:border-ink"
      />
    </label>
  );
};

/** Inline-Fehlermeldung. */
AuthCard.Fehler = function Fehler({ text }) {
  return (
    <p className="rounded-lg border border-red-300 bg-red-50 px-3 py-2 text-sm text-red-700">
      {text}
    </p>
  );
};

/** Absende-Button mit Lade-Zustand. */
AuthCard.Button = function Button({ laeuft, children }) {
  return (
    <button
      type="submit"
      disabled={laeuft}
      className="mt-2 rounded-lg bg-ink px-4 py-2.5 text-sm font-medium text-paper transition-opacity hover:opacity-90 disabled:opacity-60"
    >
      {laeuft ? 'Bitte warten…' : children}
    </button>
  );
};
